import React from 'react';

import AreaEditor from './AreaEditor';
import ListView from '../shared/lists/ListView';
import useAutoCollection from '../../utilities/useAutoCollection';

// Shared Area List
const AreaList = ({
    items,
    proposalId,
    jobId,
    formChange,
    disabled
}) => {
    const setData = (data) => formChange({ target: { name: 'areas', value: data } });

    const newItem = {
        id: 0,
        proposalId: proposalId,
        jobId: jobId,
        areaTypeId: 0,
        color: '', amount: ''
    };

    const { itemChange, itemDelete } = useAutoCollection(items, setData, !disabled, newItem);
    
    const tableHead = (
        <thead className="border-0 d-none">
        </thead>
    );

    const getItems = () => {
        const keyedItems = items.filter(item => item.reactKey !== undefined);
        return keyedItems.map((item, index) =>
            (
                <AreaEditor
                    deleteItem={() => itemDelete(index)}
                    formChange={(e) => itemChange(e, index)}
                    item={item}
                    key={item.reactKey}
                    disabled={disabled}
                />
            ));
    }

    return (
        <ListView
            className="child-list"
            itemName="Area"
            items={getItems()}
            tableHead={tableHead}
        />
    );
}

export default AreaList;